import { defineComponent as _defineComponent } from 'vue'

import CollectionTable from '@/components/collections/CollectionTable.vue';

type Props = {
  title: string;
  resource: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {



return { __sfc: true,CollectionTable }
}

})